import { trigger, state, style, transition, animate } from '@angular/animations';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { delay, filter, tap } from 'rxjs/operators';
import { BaseWrapperDirective } from '../../classes/base-wrapper';
import { ToastType } from '../../enums/ToastType.enum';
import { ToastService } from '../../services/toast.service';

export interface Toast {
  type: ToastType;
  message: string;
}

@Component({
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: [
    trigger('detailExpand', [
      state('inactive', style({ bottom: '-64px' })),
      state('active', style({ bottom: '32px' })),
      transition('inactive <=> active', animate('400ms cubic-bezier(0.4, 0.0, 0.2, 1)'))
    ])
  ],
  standalone: false
})
export class ToastComponent extends BaseWrapperDirective implements OnInit {

  toastActive$: boolean;
  payload$: Toast;

  constructor(private toastService: ToastService) {
    super();
  }

  ngOnInit(): void {
    this.subs.sink = this.toastService.toasted$.pipe(
      filter(() => !this.toastActive$),
      tap((payload) => this.payload$ = payload),
      tap(() => this.toastActive$ = true),
      delay(3000),
      tap(() => this.toastActive$ = false),
      delay(500),
      tap(() => this.payload$ = null)
    ).subscribe();
  }

  get iconClass() {
    return this.payload$?.type || '';
  }
}